import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { find, propEq } from 'ramda';
import {
  Row,
  Col,
  Modal,
  // FormGroup,
  // FormControl,
  // ControlLabel,
  // Button,
} from 'react-bootstrap';

import countries from 'country-calling-code';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import AvatarUploader from '../AvatarUploader';
import PlanModal from '../UserPlan/PlanModal';
import UserForm from './UserForm';
import MarketingContent from './MarketingContent';
import Subscription from './Subscription';
import { getCurrentPlan } from '../../utils';

class UserEdit extends Component {
  constructor() {
    super();
    this.state = {
      avatar: '',
      fullName: '',
      address: '',
      city: '',
      state: '',
      postal: '',
      country: '',
      countryCode: '',
      tel: '',
      phoneVerified: false,
      verifiedNumber: null,
      verifiedCountryCode: null,
      attorney: false,
      company: '',
      title: '',
      use_company: false,
      subscriptionPlan: '',
      planModalOpen: false,
      openTNCModal: false,
      marketingTwitter: '',
      marketingFacebook: '',
      marketingInstagram: '',
      marketingQuestion1: '',
      marketingQuestion2: '',
      marketingQuestion3: '',
      isFreeDowngrade: false,
      inviterEmail: '',
    };
  }

  componentWillMount() {
    this.props.loadProfile();
  }

  componentWillReceiveProps(nextProps) {
    const { status, profile, statusPayment } = nextProps;

    if (status !== this.props.status) {
      if (status === actionTypes.PROFILE_GET_SUCCESS) {
        this.setUserForm(nextProps);

        if (profile.braintree_customer_id) {
          this.props.loadCustomer();
        }
      } else if (status === actionTypes.PROFILE_UPDATE_ERROR) {
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      } else if (status === actionTypes.PROFILE_UPDATE_SUCCESS) {
        this.props.alert(
          'success',
          'Your profile has been updated successfully!'
        );
        this.props.router.push('/');
      }

      if (status === actionTypes.GET_MARKETING_CONTENT_SUCCESS) {
        if (profile.marketingContent && profile.marketingContent.length > 0) {
          this.setState({
            marketingTwitter: profile.marketingContent[0].twitter || '',
            marketingFacebook: profile.marketingContent[0].facebook || '',
            marketingInstagram: profile.marketingContent[0].instagram || '',
            marketingQuestion1: profile.marketingContent[0].question1 || '',
            marketingQuestion2: profile.marketingContent[0].question2 || '',
            marketingQuestion3: profile.marketingContent[0].question3 || '',
          });
        }
      }
    }

    if (status !== actionTypes.PROFILE_UPDATE_REQUEST) {
      this.setState({ avatar: profile.avatar, fullName: profile.name || '' });
    }

    if (statusPayment !== this.statusPayment) {
      if (statusPayment === actionTypes.PAYMENT_CANCEL_SUBSCRIBE_SUCCESS) {
        if (this.state.isFreeDowngrade) {
          this.props.alert(
            'success',
            'Success! You will downgraded to the free tier on your next renewal date.'
          );
        } else {
          this.props.alert(
            'success',
            'Success! You have canceled your subscription.'
          );
        }

        this.props.loadCustomer();
        this.props.loadProfile();
        this.setState({ isFreeDowngrade: false });
      } else if (statusPayment === actionTypes.PAYMENT_CANCEL_SUBSCRIBE_ERROR) {
        this.setState({ isFreeDowngrade: false });
        this.props.alert(
          'error',
          'Something went wrong. Subscription cancellation failed.'
        );
      }
    }
  }

  componentDidMount() {
    this.unregisterRouteHook = this.props.router.setRouteLeaveHook(
      this.props.routes[2],
      this.routerWillLeave
    );
  }

  routerWillLeave = (nextLocation) => {
    const { fullName, address, city, state, postal /*tel, phoneVerified*/ } =
      this.state;
    // const verified = (fullName && address && city && state && postal && country && tel && phoneVerified);
    const verified = fullName && address && city && state && postal;

    if (verified) {
      return true;
    } else {
      this.props.alert('error', 'Please complete your profile first.');
      return false;
    }
  };

  setUserForm(props) {
    const { profile } = props;

    // let country;
    // country = find(propEq('country', profile.country))(countries);

    this.setState({
      fullName: profile.name || '',
      address: profile.address || '',
      city: profile.city || '',
      state: profile.state || '',
      postal: profile.postal || '',
      // country: country ? country.country : '',
      // countryCode: country ? country.countryCodes[0] : '',
      // tel: profile.tel || '',
      // phoneVerified: profile.phone_verified || false,
      // verifiedNumber: profile.phone_verified ? profile.tel : null,
      // verifiedCountryCode: profile.phone_verified ? country.countryCodes[0] : null,
      country: profile.country || '',
      countryCode: '',
      tel: '',
      phoneVerified: false,
      verifiedNumber: null,
      verifiedCountryCode: null,
      attorney: profile.attorney || false,
      company: profile.company_name || '',
      title: profile.user_title || '',
      use_company: profile.use_company_name || false,
      subscriptionPlan: profile.subscription_plan
        ? profile.subscription_plan
        : 'free',
    });

    if (profile.id) {
      this.props.getMarketingContent(profile.id);
    }
  }

  handleUpload = (file) => {
    if (file && file.url) {
      this.setState({ avatar: file.url });
    } else {
      this.setState({ avatar: '' });
    }
  };

  handleUnsubscribe = (e) => {
    e.preventDefault();
    this.props.cancelSubscribe({});
  };

  handleValue = (e, key) => {
    this.setState({ [key]: e.target.value }, () => {
      if (key === 'tel') {
        this.checkAlreadyVerified();
      }
    });
  };

  handleCheck = (e, key) => {
    this.setState({ [key]: e.target.checked });
  };

  handleCountry = (e) => {
    const country = find(propEq('country', e.target.value))(countries);
    if (country) {
      this.setState(
        { country: country.country, countryCode: country.countryCodes[0] },
        this.checkAlreadyVerified
      );
    } else {
      this.setState({ country: '', countryCode: '', phoneVerified: false });
    }
  };

  checkAlreadyVerified() {
    this.setState({
      phoneVerified:
        this.state.tel === this.state.verifiedNumber &&
        this.state.countryCode === this.state.verifiedCountryCode,
    });
  }

  handleVerify = (success, number, countryCode) => {
    if (success) {
      this.setState({
        phoneVerified: true,
        verifiedNumber: number,
        verifiedCountryCode: countryCode,
      });
    } else {
      this.setState({
        phoneVerified: false,
        verifiedNumber: number,
        verifiedCountryCode: countryCode,
      });
    }
  };

  save = (e) => {
    e.preventDefault();

    this.props.hideAlert();

    // if (this.state.phoneVerified) {
    let data = {
      avatar: this.state.avatar,
      name: this.state.fullName,
      address: this.state.address,
      city: this.state.city,
      state: this.state.state,
      postal: this.state.postal,
      country: this.state.country,
      tel: '',
      // phone_verified: this.state.phoneVerified,
      phone_verified: true,
      attorney: this.state.attorney,
      company_name: this.state.company,
      user_title: this.state.title,
      use_company_name: this.state.use_company,
      // subscription_plan: this.state.subscriptionPlan,
    };
    this.props.updateProfile(data);
    // } else {
    //     this.props.alert('error', "Please verify your phone number.");
    // }
  };

  onUpgradePlan = (e) => {
    e.preventDefault();
    this.setState({ planModalOpen: true });
  };

  openTNCModal = (e) => {
    e.preventDefault();
    this.setState({ openTNCModal: true });
  };

  closeTNCModal = () => {
    this.setState({ openTNCModal: false });
  };

  saveMarketingContent = () => {
    const { profile } = this.props;

    let data = {
      user_id: profile.id,
      email: profile.email,
      twitter: this.state.marketingTwitter,
      facebook: this.state.marketingFacebook,
      instagram: this.state.marketingInstagram,
      question1: this.state.marketingQuestion1,
      question2: this.state.marketingQuestion2,
      question3: this.state.marketingQuestion3,
    };

    if (
      data.twitter !== '' ||
      data.facebook !== '' ||
      data.instagram !== '' ||
      data.question1 !== '' ||
      data.question2 !== '' ||
      data.question3 !== ''
    ) {
      if (profile.marketingContent && profile.marketingContent.length > 0) {
        data = {
          id: profile.marketingContent[0].id,
          ...data,
        };
        this.props.updateMarketingContent(data);
      } else {
        this.props.createMarketingContent(data);
      }

      this.props.router.push(`/`);
    } else {
      this.props.alert('error', 'Please fill the marketing content.');
    }
  };

  renderUserForm() {
    const { profile, subscription } = this.props;
    const { subscriptionPlan } = this.state;

    const currentPlan = getCurrentPlan(
      subscription,
      subscriptionPlan,
      profile.trial_expired,
      profile
    );

    return (
      <UserForm
        state={this.state}
        profile={profile}
        currentPlan={currentPlan}
        subscriptionPlan={subscriptionPlan}
        handleSave={this.save}
        handleValue={this.handleValue}
        handleCountry={this.handleCountry}
        handleVerify={this.handleVerify}
        handleCheck={this.handleCheck}
        onUpgradePlan={this.onUpgradePlan}
      />
    );
  }

  renderCards() {
    const { customer } = this.props;

    return (
      <div className="payment-info">
        <h4>Credit Cards</h4>
        {customer.credit_cards.map((card, i) => (
          <div key={i} className="credit-card">
            <img src={card.image_url} alt={card.card_type} />
            <span>Ending in **{card.last_4}</span>
            {card.default && <span className="text-green">Active</span>}
          </div>
        ))}
      </div>
    );
  }

  handleFreeDowngrade = () => {
    this.setState({ planModalOpen: false, isFreeDowngrade: true });
    this.props.cancelSubscribe({});
  };

  fixAgreementInviteIssue = () => {
    const { inviterEmail } = this.state;
    if (inviterEmail !== '') {
      this.props.fixAgreementInviteIssue({ email: inviterEmail });
    }
  };

  render() {
    const { customer, subscription, profile } = this.props;
    const {
      marketingTwitter,
      marketingFacebook,
      marketingInstagram,
      marketingQuestion1,
      marketingQuestion2,
      marketingQuestion3,
    } = this.state;

    let isPremiumExpired =
      profile &&
      profile.subscription_plan === 'premium' &&
      profile.trial_expired === true;

    return (
      <div className="user-profile">
        <div className="user-edit">
          <Row>
            <Col sm={4}>
              <div className="user-photo">
                <AvatarUploader
                  size="150"
                  onUpload={this.handleUpload}
                  image={this.state.avatar}
                >
                  <p className="add-picture">Add a picture</p>
                </AvatarUploader>
              </div>
            </Col>
            <Col sm={8}>{this.renderUserForm()}</Col>
          </Row>
        </div>

        <MarketingContent
          marketingTwitter={marketingTwitter}
          marketingFacebook={marketingFacebook}
          marketingInstagram={marketingInstagram}
          marketingQuestion1={marketingQuestion1}
          marketingQuestion2={marketingQuestion2}
          marketingQuestion3={marketingQuestion3}
          openTNCModal={this.openTNCModal}
          handleValue={this.handleValue}
          saveMarketingContent={this.saveMarketingContent}
        />

        {customer && customer.credit_cards.length ? this.renderCards() : null}
        {customer && subscription && (
          <Subscription
            profile={profile}
            subscription={subscription}
            handleUnsubscribe={this.handleUnsubscribe}
          />
        )}

        {/* {profile && profile.email === 'dmitry@cosynd.com' && (
          <div className="payment-info agreement-invite-fixer-container">
            <h4>
              Fix agreement invite issue automatically by inviter email (D only)
            </h4>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>Inviter Email:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                className="inline"
                required
                value={this.state.inviterEmail}
                onChange={(e) => this.handleValue(e, 'inviterEmail')}
              />

              <div className="actions">
                <Button onClick={this.fixAgreementInviteIssue}>
                  Fix agreement invite issue
                </Button>
              </div>
            </FormGroup>
          </div>
        )} */}

        {profile.subscription_plan !== undefined && (
          <PlanModal
            show={this.state.planModalOpen}
            subscriptionPlan={profile.subscription_plan}
            referrer={profile.referrer}
            showAllPlan={true}
            isPremiumExpired={isPremiumExpired}
            isCanceledSubscription={
              subscription &&
              subscription.status === 'Canceled' &&
              profile.subscription_plan === 'free'
            }
            hidePlanModal={() => this.setState({ planModalOpen: false })}
            handleFreeDowngrade={this.handleFreeDowngrade}
          />
        )}

        <Modal
          className="copyright-certain-works-modal"
          show={this.state.openTNCModal}
          onHide={() => this.closeTNCModal()}
        >
          <Modal.Body>
            <div>
              By submitting content (including, without limitation, text,
              photographs, graphics, audio, videos, and any other materials)
              (the "Content") to Cosynd, Inc. ("Cosynd") via this form, you
              hereby grant to Cosynd a non-exclusive, perpetual, worldwide,
              irrevocable, gratis, royalty-free license to reproduce,
              distribute, display, perform, modify, edit, and otherwise use the
              Content in any and all media for Cosynd's promotional purposes,
              including, without limitation, on its website, social media
              accounts, and marketing materials. For the avoidance of doubt, the
              foregoing sentence shall not grant Cosynd any ownership rights to
              the Content nor shall Cosynd have the right to exploit the Content
              for any commercial purposes without your prior consent.
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  status: state.profile.status,
  statusPayment: state.payment.status,
  customer: state.payment.customer,
  subscription: state.payment.subscription,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  loadProfile: () => {
    dispatch(actions.getProfile());
  },
  updateProfile: (profile) => {
    dispatch(actions.updateProfile(profile));
  },
  loadCustomer: () => {
    dispatch(actions.getCustomer({}));
  },
  cancelSubscribe: (options) => {
    dispatch(actions.cancelSubscribe(options));
  },
  getMarketingContent: (userId) => {
    dispatch(actions.getMarketingContent(userId));
  },
  updateMarketingContent: (data) => {
    dispatch(actions.updateMarketingContent(data));
  },
  createMarketingContent: (data) => {
    dispatch(actions.createMarketingContent(data));
  },
  fixAgreementInviteIssue: (data) => {
    dispatch(actions.fixAgreementInviteIssue(data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserEdit));



// WEBPACK FOOTER //
// src/components/Profile/UserEdit.jsx